import Cookies from "js-cookie";
import { React, useState, useEffect } from "react";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import {
  Autocomplete,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TablePagination,
  Paper,
  Button, 
  TextField, 
  Modal, 
  MenuItem, 
  Tooltip
} from "@mui/material";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import IconButton from "@mui/material/IconButton";
import BackupTableIcon from "@mui/icons-material/BackupTable";
import TableViewIcon from "@mui/icons-material/TableView";
import FormControl from "@mui/material/FormControl";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import Grid from "@mui/material/Grid";
import { Slide, toast } from 'react-toastify';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

import "../../style/datasurvey.css"

// External
import Navbar from "../../Components/Navbar";
import { fetchProfile } from "../../utils/fetchProfile";
import { fetchUserFormatted } from "../../utils/fetchUser";
import { ModalConfirmation } from "../../Components/Fragments/Modals/ModalGeneral";

// Custom CSS
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "0px solid #000",
  boxShadow: 24,
  p: 4,
};

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundImage: "linear-gradient(#0ab9cc, #069dae)",
    border: "solid 1px #fff",
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

function DataSurvey() {
  //data period
  const [dataPeriode, setDataPeriode] = useState([]);
  const [selectedPeriodeId, setSelectedPeriodeId] = useState(
    localStorage.getItem("selectedPeriodeId") || "all"
  );

  // Initial
  const [isLoading, setIsLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(10);
  const [sortBy, setSortBy] = useState('');
  const [sortOrder, setSortOrder] = useState('');
  const [totalRows, setTotalRows] = useState(0);
  const accessToken = Cookies.get("access_token") || "";
  const [initialText, setInitialText] = useState("");
  const [selectedSurveyId, setSelectedSurveyId] = useState("");
  const [openDialogConfirmationExport, setOpenDialogConfirmationExport] = useState(false);
  const [viewDataExport, setViewDataExport] = useState({
    title: null,
    process_at: null,
  });
    const [tempColumnValue, setTempColumnValue] = useState("");
    const [filterColumnValue, setFilterColumnValue] = useState("");
    const [filterColumnName, setFilterColumnName] = useState("");
    const [filterColumnOperator, setFilterColumnOperator] = useState("");

  const [rowModesModel, setRowModesModel] = useState({});
  const [surveyData, setSurveyData] = useState([]);

  const dataAuditStatus = [
    // {
    //   label: "SEMUA",
    //   value: "all",
    // },
    {
      label: "Closed",
      value: "Closed",
    },
    {
      label: "On Progress",
      value: "On Progress",
    },
    {
      label: "Valid",
      value: "Valid",
    },
    {
      label: "Not Started",
      value: "Not Started",
    },
  ];
  const [notAllowAccessPage, setNotAllowAccessPage] = useState(false);
  const [dataProfile, setDataProfile] = useState([]);

  // Handling modal
  const [modalAdd, setModalAdd] = useState(false);

  // Token
  const token = Cookies.get("access_token") || "";

  // Button style
  const BootstrapButton = styled(Button)({
    boxShadow: "none",
    textTransform: "none",
    fontSize: 14,
    padding: "3px 10px",
    border: "1px solid",
    lineHeight: 1.5,
    backgroundColor: "#069DAE",
    fontFamily: ["Roboto"].join(","),
    "&:hover": {
      backgroundColor: "#0696A6",
      boxShadow: "none",
    },
    "&:active": {
      boxShadow: "none",
      backgroundColor: "#0062cc",
      borderColor: "#005cbf",
    },
    "&:focus": {
      boxShadow: "0 0 0 0.2rem rgba(0,123,255,.5)",
    },
  });

  const handleRowModesModelChange = (newRowModesModel) => {
    setRowModesModel(newRowModesModel);
  };

  // Download
  const [selectedDownload, setSelectedDownload] = useState(null);
  const [filterDownload, setFilterDownload] = useState([]);

  async function fetchProjectData(token, periodeCode, setSurveyData) {
    setSurveyData([])
    if (periodeCode && periodeCode !== 'all') {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/api/v1/project?period=${periodeCode}`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
        if (response.status === 200) {
          const { data } = await response.json();
          const transformedData = data.map((project) => ({
            value: project.survey_id,
            label: project.project_name,
            type: project.project_type_name,
          }));

          setFilterDownload(transformedData);

          if (transformedData.length > 0) {
            setSelectedSurveyId(transformedData[0].value);
            setSurveyType(transformedData[0].type);
          }
        } else {
          throw new Error("Failed to fetch project data");
        }
      } catch (error) {
        console.error(error);
      }
    }
  }

  useEffect(() => {
    const handler = setTimeout(() => {
      fetchProfile(accessToken, setDataProfile, setNotAllowAccessPage, []);
      fetchPeriodeFormatted(accessToken, setDataPeriode);
    }, 300);
    return () => {
      clearTimeout(handler);
    };
  }, []);

  useEffect(() => {
    const handler = setTimeout(() => {
      fetchProjectData(accessToken, selectedPeriodeId, setSurveyData);
    }, 500);
    return () => {
      clearTimeout(handler);
    };
  }, [selectedPeriodeId]);

  // selected
  const [provinceCode, setProvinceCode] = useState("all");
  const [tipeSurveyCode, setTipeSurveyCode] = useState("");
  const [usernameSurveyorCode, setUsernameSurveyorCode] = useState("");
  const [regencyCode, setRegencyCode] = useState("all");
  const [districtCode, setDistrictCode] = useState("all");
  const [subDistrictCode, setSubDistrictCode] = useState("all");
  const [selectedAuditStatus, setSelectedAuditStatus] = useState([]);

  const provinceInputText = "SEMUA";
  const tipeSurveyInputText = "SEMUA";
  const usernameSurveyorInputText = "SEMUA";
  const [regencyInputText, setRegencyInputText] = useState("SEMUA");
  const [districtInputText, setDistrictInputText] = useState("SEMUA");
  const [subDistrictInputText, setSubDistrictInputText] = useState("SEMUA");

  // all data
  const [provinces, setProvinces] = useState([]);
  const [dataSurveyType, setDataSurveyType] = useState([]);

  const [dataUserSurveyor, setDataUserSurveyor] = useState([]);
  const [dataUserSurveyorOptions, setDataUserSurveyorOptions] = useState([]);
  const [dataUserQcOptions, setDataUserQcOptions] = useState([]);

  const [regencies, setRegencies] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [subDistricts, setSubDistricts] = useState([]);

  const setDefaultSelectedPeriode = () => {
    if (dataPeriode.length > 0) {
      // Check if the currently selected periode is still available in the data
      const selectedOption = dataPeriode.find(option => option.id === selectedPeriodeId);
      if (selectedOption) {
        setSelectedPeriodeId(selectedOption.id);
      } else {
        // If the selected option is not available, set the first option as default
        setSelectedPeriodeId(dataPeriode[0].id);
      }
    }
  };

  const setDefaultSelectedProject = () => {
    if (surveyData.length > 0) {
      // Check if the currently selected project is still available in the data
      const selectedOption = surveyData.find(option => option.id === selectedSurveyId);
      if (selectedOption) {
        setSelectedSurveyId(selectedOption.id);
      } else {
        // If the selected option is not available, set the first option as default
        setSelectedSurveyId(surveyData[0].id);
      }
    }
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      setDefaultSelectedPeriode();
      setDefaultSelectedProject();
    }, 300);
    return () => {
      clearTimeout(handler);
    };
  }, [dataPeriode]);

  async function fetchPeriodeFormatted(token, setDataPeriode) {
    setDataPeriode([]);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/v1/project/period`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.ok) {
        const data = await response.json();
        const newArray = data.data.map(item => ({
          label: item.period.toString(), // Mengonversi period menjadi string
          id: item.period.toString(),
        }));
        setDataPeriode(newArray);
      } else {
        setDataPeriode([]);
      }
    } catch (error) {
      console.error(error);
    }
  }

  async function fetchTipeSurvey() {
    try {
      const token = Cookies.get("access_token");
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/v1/tipe-survey`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200) {
        const data = await response.json();
        const newArray = data.data.map((item) => ({
          label: item.desc,
          id: item.desc,
        }));
        setDataSurveyType(newArray);
      } else {
        setDataSurveyType();
      }
    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
    const handler = setTimeout(() => {
      fetchTipeSurvey();
    }, 300);
    return () => {
      clearTimeout(handler);
    };
  }, []);

  useEffect(() => {
    const handler = setTimeout(() => {
      fetchUserFormatted(accessToken, setDataUserSurveyorOptions, "13");
      fetchUserFormatted(accessToken, setDataUserSurveyor, "13");
      fetchUserFormatted(accessToken, setDataUserQcOptions, "14");
    }, 300);
    return () => {
      clearTimeout(handler);
    };
  }, []);

  async function fetchProvinces() {
    try {
      const token = Cookies.get("access_token");
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/v1/province`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200) {
        const { data } = await response.json();
        setProvinces(data);
      } else {
        setProvinces();
      }
    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
    const handler = setTimeout(() => {
      fetchProvinces();
    }, 300);
    return () => {
      clearTimeout(handler);
    };
  }, []);

  async function fetchRegencies(province_code) {
    if (province_code !== "all") {
      try {
        const token = Cookies.get("access_token");
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/api/v1/regency?province_code=${province_code}`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (response.status === 200) {
          const data = await response.json();
          setRegencies(data.data);
        } else {
          throw new Error("Ada masalah saat mengambil kabupaten");
        }
      } catch (error) {
        console.error(error);
      }
    }
  }

  async function fetchDistricts(province_code, regency_code) {
    if (regency_code !== "all") {
      try {
        const token = Cookies.get("access_token");
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/api/v1/district?province_code=${province_code}&regency_code=${regency_code}`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (response.status === 200) {
          const data = await response.json();
          setDistricts(data.data);
        } else {
          throw new Error("Error when fetch district");
        }
      } catch (error) {
        console.error(error);
      }
    }
  }

  async function fetchSubDistricts(province_code, regency_code, district_code) {
    if (districtCode !== "all") {
      try {
        const token = Cookies.get("access_token");
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/api/v1/sub-district?province_code=${province_code}&regency_code=${regency_code}&district_code=${district_code}&need_detail_info=false`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (response.status === 200) {
          const data = await response.json();
          setSubDistricts(data.data);
        } else {
          throw new Error("Error when fetch sub district");
        }
      } catch (error) {
        console.error(error);
      }
    }
  }

  const handleProvinceCodeChange = (event) => {
    setPage(1);
    const selectedProvinceCode = event.target.value;
    setProvinceCode(selectedProvinceCode);
    setRegencyInputText("SEMUA");
    setRegencyCode("all");
    setDistrictCode("all");
    setSubDistrictCode("all");
  };

  const handleRegencyCodeChange = (event) => {
    setPage(1);
    const selectedRegencyCode = event.target.value;
    setDistrictInputText("SEMUA");
    setRegencyCode(selectedRegencyCode);
    setDistrictCode("all");
  };

  const handleDistrictCodeChange = (event) => {
    setPage(1);
    const selectedDistrictCode = event.target.value;
    setSubDistrictInputText("SEMUA");
    setDistrictCode(selectedDistrictCode);
    setSubDistrictCode("all");
  };

  const handleSubDistrictCodeChange = (event) => {
    setPage(1);
    const selectedSubDistrictCode = event.target.value;
    setSubDistrictCode(selectedSubDistrictCode);
  };

  async function createDataSurveyProcess() {
    setIsLoading(true);
    try {
      const surveyId = selectedSurveyId;
      const selectedLabel = filterDownload.find(
        (option) => option.value === selectedSurveyId
      )?.label;

      const selectedAuditStatusFilter = selectedAuditStatus.join(',');

      const formData = {
        title: `Rawdata ${selectedLabel}`,
        audit_status: selectedAuditStatusFilter,
        tipe_survey: tipeSurveyCode,
        province_code: provinceCode == "all" ? "" : provinceCode,
        regency_code: regencyCode == "all" ? "" : regencyCode,
        district_code: districtCode == "all" ? "" : districtCode,
        survey_id: surveyId
      }

      // const response = await fetch(`${process.env.REACT_APP_API_URL}/api/v1/process_queue/data_surveys`, {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/v1/rawdata/process_queue/data_surveys`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(formData),
      });

      if (response.status === 201 || response.status === 200 || response.status === 202) {
        toast.success('data akan diproses kedalam antrian', {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Slide,
        });
      } else if (response.status === 400) {
        const message = await response.json();
        toast.error(message?.detail, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Slide,
        });
      } else if (response.status === 404) {
        toast.error('data tidak ditemukan', {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Slide,
        });
      } else {
        toast.error('ada masalah saat menyimpan data', {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Slide,
        });
      }
    } catch (error) {
      console.error('Error creating process queue:', error);
    }
    setIsLoading(false);
  }

  const handleConfirmationExport = async () => {
    setIsLoading(true);
    const response = await fetch(`${process.env.REACT_APP_API_URL}/api/v1/process_queue/data_surveys/${selectedSurveyId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`,
      },
    });

    if (response.status === 200) {
      const { data } = await response.json();
      setOpenDialogConfirmationExport(true);
      setViewDataExport({
        title: data.data.title ?? "rawdata",
        process_at: data.process_at,
      });
    } else if (response.status === 400 || response.status === 404) {
      const { detail } = await response.json();
      toast.error(detail || "Data sedang diproses", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Slide,
      });
    } else {
      const { detail } = await response.json();
      toast.error(detail || "Tidak ditemukan excel, klik Process terlebih dahulu", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Slide,
      });
    }
    setIsLoading(false);
  };

  const handleCloseDialog = () => {
    setOpenDialogConfirmationExport(false);
    // clear data
    setViewDataExport({
      title: "",
      process_at: "",
    });
  };

  // export
  const handleExport = async () => {
    setIsLoading(true);
    try {
      const queryParams = new URLSearchParams();

      // Construct the full URL with query parameters
      const queryString = queryParams.toString();
      const apiUrl =
        `${process.env.REACT_APP_API_URL}/api/v1/process_queue/data_surveys/export/${selectedSurveyId}` +
        (queryString ? `?${queryString}` : "");

      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });

      const selectedLabel = filterDownload.find(
        (option) => option.value === selectedSurveyId
      )?.label;

      if (response.status === 200) {
        const blob = await response.blob();
        const filename = `${selectedLabel}.xlsx`;
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = filename;
        a.click();
      } else if (response.status === 400 || response.status === 404) {
        const data = await response.json();
        toast.error(data.detail, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Slide,
        });
      } else {
        toast.error('Gagal mengunduh', {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Slide,
        });
        console.error('Failed to export process queue:', response.statusText);
      }
    } catch (error) {
      console.error('Error export process queue:', error);
    }
    setIsLoading(false);
  };

  // read
  async function fetchData(
    token,
    selectedSurveyId,
    selectedProvinceId = "all",
    selectedRegencyId = "all",
    selectedDistrictId = "all",
    selectedSubDistrictId = "all",
    selectedAuditStatus = [],
    selectedTipeSurveyId = "",
    selectedUsernameSurveyorId = "",
    selectedIsNegative = "",
    filterColumnName = '', 
    filterColumnValue = '', 
    filterColumnOperator = '',
    page = 1,
    size = 10,
    sortBy = "",
    sortOrder = "",
  ) {
    setIsLoading(true);
    if (selectedSurveyId) {
      // Create an empty URLSearchParams object
      const queryParams = new URLSearchParams();

      // Add selectedAuditStatus to the query if it's provided
      if (selectedAuditStatus.length > 0) {
        selectedAuditStatus.forEach((status) => {
          queryParams.append("audit_status", status);
        });
      }

      // Add selectedIsNegative to the query if it's provided
      if (typeof selectedIsNegative === 'boolean') {
        queryParams.append("is_negative", selectedIsNegative.toString());
      }

      // Add selectedSurveyType to the query if it's provided
      if (selectedTipeSurveyId && selectedTipeSurveyId !== "") {
        queryParams.append("tipe_survey", selectedTipeSurveyId);
      }

      // Add selectedSurveyType to the query if it's provided
      if (selectedUsernameSurveyorId && selectedUsernameSurveyorId !== "") {
        queryParams.append("user_name_surveyor", selectedUsernameSurveyorId);
      }

      // Add selectedProvinceId to the query if it's provided
      if (selectedProvinceId && selectedProvinceId !== "all") {
        queryParams.append("province_code", selectedProvinceId);
      }

      // Add selectedRegencyId to the query if it's provided
      if (selectedRegencyId && selectedRegencyId !== "all") {
        queryParams.append("regency_code", selectedRegencyId);
      }

      // Add selectedDistrictId to the query if it's provided
      if (selectedDistrictId && selectedDistrictId !== "all") {
        queryParams.append("district_code", selectedDistrictId);
      }

      // Add selectedSubDistrictId to the query if it's provided
      if (selectedSubDistrictId && selectedSubDistrictId !== "all") {
        queryParams.append("sub_district_code", selectedSubDistrictId);
      }

      // Add selectedSubDistrictId to the query if it's provided
      if (selectedSubDistrictId && selectedSubDistrictId !== "all") {
        queryParams.append("sub_district_code", selectedSubDistrictId);
      }

      if (filterColumnName && filterColumnValue) {
        queryParams.append('column_operator', filterColumnOperator);
        queryParams.append('column_name', filterColumnName);
        queryParams.append('column_value', filterColumnValue);
      }

      if (sortBy && sortOrder) {
        queryParams.append('sort_by', sortBy);
        queryParams.append('sort_order', sortOrder);
      }

      queryParams.append("page", page);
      queryParams.append("size", size);

      // Construct the full URL with query parameters
      const queryString = queryParams.toString();
      const apiUrl =
        `${process.env.REACT_APP_API_URL}/api/v1/survey/store/${selectedSurveyId}` +
        (queryString ? `?${queryString}` : "");

      try {
        setSurveyData([]);
        setInitialText("Loading...");
        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (response.status === 200) {
          const { data, pagination_info } = await response.json();
          setInitialText("");
          setSurveyData(data);
          setTotalRows(pagination_info.total); 
        } else if (response.status === 404) {
          setSurveyData([]);
          // Handle error
          setInitialText("No data found");
        }
      } catch (error) {
        // Handle error
      }
    }
    setIsLoading(false);
  }

  useEffect(() => {
    const handler = setTimeout(() => {
      fetchRegencies(provinceCode);
      fetchDistricts(provinceCode, regencyCode);
      fetchSubDistricts(provinceCode, regencyCode, districtCode);
      // Check if a survey ID is selected before making the API call
      if (selectedSurveyId) {
        fetchData(
          accessToken,
          selectedSurveyId,
          provinceCode,
          regencyCode,
          districtCode,
          subDistrictCode,
          selectedAuditStatus,
          tipeSurveyCode,
          usernameSurveyorCode,
          selectedPeriodeId,
          filterColumnName,
          filterColumnValue,
          filterColumnOperator,
          page,
          size,
          sortBy,
          sortOrder,
        );
      }
    }, 300);
    return () => {
      clearTimeout(handler);
    };
  }, [
    accessToken,
    selectedSurveyId,
    provinceCode,
    regencyCode,
    districtCode,
    subDistrictCode,
    selectedAuditStatus,
    tipeSurveyCode,
    usernameSurveyorCode,
    selectedPeriodeId,
    filterColumnValue,
    page,
    size,
    sortBy,
    sortOrder,
  ]);

  // Handle change in the dropdown selection
  const handleProjectChange = (event) => {
    setPage(1);
    const selectedId = event.target.value;
    setSelectedSurveyId(selectedId);

    localStorage.setItem("selectedSurveyId", selectedId);

    const selectedProject = filterDownload.find(
      (project) => project.value === selectedId
    );

    if (selectedProject) {
      setSurveyType((prevSurveyType) => selectedProject.type);
    } else {
      console.error("Project not found");
    }

    // Reset other state variables
    setRegencies([]);
    setDistricts([]);
    setSubDistricts([]);
    setProvinceCode("all");
    setRegencyCode("all");
    setDistrictCode("all");
    setSubDistrictCode("all");
    setRegencyInputText("SEMUA");
    setDistrictInputText("SEMUA");
    setSubDistrictInputText("SEMUA");
  };

  const handleAuditStatusChange = (event) => {
    setPage(1);
    const {
      target: { value },
    } = event;
    setSelectedAuditStatus(
      typeof value === "string" ? value.split(",") : value
    );
    localStorage.setItem("selectedAuditStatus", value);
  };

  // view trx
  const [modalOpen, setModalOpen] = useState(false);
  const [modalOpenQc, setModalOpenQc] = useState(false);
  const [modalOpenEdit, setModalOpenEdit] = useState(false);
  const [modalOpenLogCorrection, setModalOpenLogCorrection] = useState(false);

  const [selectedModalStoreCode, setSelectedModalStoreCode] = useState("");

  const [selectedProductCode, setSelectedProductCode] = useState("");

  const [modalTableData, setModalTableData] = useState([]);
  const [modalTableDataQc, setModalTableDataQc] = useState([]);

  const [selectedSurveyType, setSelectedSurveyType] = useState("");
  const [selectedStatusAudit, setSelectedStatusAudit] = useState("");

  const [surveyType, setSurveyType] = useState("");

  const openNewTab = (storeId, statusCode, surveyType, isQc) => {
    const url = `/data-survey/${selectedSurveyId}/${storeId}?is_qc=${isQc}`;
    window.open(url, '_blank');

    setSelectedStatusAudit(statusCode);
    setSelectedSurveyType(surveyType);
  };

  const handleResetFilter = () => {
    setSelectedAuditStatus([]);
    setProvinceCode("all");
    setRegencyCode("all");
    setDistrictCode("all");
    setSubDistrictCode("all");
    setUsernameSurveyorCode("");
    setTipeSurveyCode("");
    setTempColumnValue("");
    setFilterColumnValue("");
    setFilterColumnName("");
    setFilterColumnOperator("");
    setPage(1);
    setSize(10);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage + 1);
  };
  
  const handleChangeRowsPerPage = (event) => {
    setSize(parseInt(event.target.value, 10));
    setPage(1);
  };

  const handleSortChange = (newSortBy, newSortOrder) => {
    setSortBy(newSortBy);
    setSortOrder(newSortOrder);
    setPage(1)
  };

  const handleSort = (column) => {
    const newSortOrder = sortBy === column && sortOrder === 'asc' ? 'desc' : 'asc';
    handleSortChange(column, newSortOrder);
  };
  
  const renderSortIcon = (column) => {
    if (sortBy !== column) return null;
    return sortOrder === 'asc' ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />;
  };

  const surveyFilterColumnName = [
    { value: "", label: "Select", operator: "LIKE"},
    { value: "store_code", label: "Kode Outlet", operator: "LIKE" },
    { value: "store_name", label: "Nama Outlet", operator: "LIKE" },
    { value: "user_name_surveyor", label: "Username Surveyor", operator: "LIKE" },
    // { value: "user_full_name_surveyor", label: "Full Name Surveyor", operator: "LIKE" },
    // { value: "user_name_qc", label: "Username QC", operator: "LIKE" },
    { value: "user_full_name_qc", label: "Full Name QC", operator: "LIKE" },
  ];

  if (notAllowAccessPage) {
    return (
      <div>
        <Navbar
          active="Data Survey"
          initial={dataProfile.initial}
          role_code={dataProfile.role_code}
        />
        <div>Not allow to access this page</div>
      </div>
    );
  }

  return (
    <div>
      <Navbar
        active="Data Survey"
        initial={dataProfile.initial}
        role_code={dataProfile.role_code}
      />
      <div className="content" style={{ padding: "1rem 1rem 0 1rem" }}>
        <Grid container spacing={0.5}>
          <Grid item xs={12} sm={2.4}>
            <Autocomplete
              size="small"
              options={dataPeriode}
              getOptionLabel={(option) => option.label || ''}
              value={
                dataPeriode.find((option) => option.id === selectedPeriodeId) || null
              }
              onChange={(event, newValue) => {
                setPage(1);
                setSelectedPeriodeId(newValue ? newValue.id : '');
                localStorage.setItem("selectedPeriodeId", newValue ? newValue.id : '');

                setSelectedSurveyId("all");
                localStorage.setItem("selectedSurveyId", "all");
              }}
              disableClearable
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Periode"
                  sx={{
                    mr: 1,
                    mt: 1,
                    height: 40,
                    width: "100%"
                  }}
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={2.4}>
            <TextField
              id="outlined-select-currency"
              label="Project - Survey"
              select
              sx={{
                mr: 1,
                mt: 1,
                height: 40,
                width: "100%"
              }}
              size="small"
              value={selectedSurveyId}
              onChange={handleProjectChange}
            >
              {filterDownload.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12} sm={2.4}>
            <FormControl sx={{ height: 40, mt: 1, mr: 1, width: "100%"}}>
              <InputLabel sx={{ mt: "-5px" }} id="demo-multiple-name-label">
                Status
              </InputLabel>
              <Select
                multiple
                sx={{ height: 40 }}
                labelId="demo-multiple-name-label"
                id="demo-multiple-name"
                value={selectedAuditStatus}
                onChange={handleAuditStatusChange}
                input={<OutlinedInput label="Status" />}
              >
                {dataAuditStatus.map((data) => (
                  <MenuItem key={data.value} value={data.value}>
                    {data.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={2.4}>
            <Autocomplete
              size="small"
              options={dataSurveyType}
              getOptionLabel={(option) => option.label || ''}
              value={
                dataSurveyType.find((option) => option.id === tipeSurveyCode) || null
              }
              onChange={(event, newValue) => {
                setPage(1);
                setTipeSurveyCode(newValue ? newValue.id : '');
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Tipe Survey"
                  sx={{
                    mr: 1,
                    mt: 1,
                    height: 40,
                    width: "100%"
                  }}
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={2.4}>
            <Autocomplete
              size="small"
              options={dataUserSurveyor}
              getOptionLabel={(option) => option.label || ''}
              value={
                dataUserSurveyor.find((option) => option.id === usernameSurveyorCode) || null
              }
              onChange={(event, newValue) => {
                setPage(1);
                setUsernameSurveyorCode(newValue ? newValue.id : '');
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Full Name Surveyor"
                  sx={{
                    mr: 1,
                    mt: 1,
                    height: 40,
                    width: "100%"
                  }}
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={2.4}>
            <TextField
              id="outlined-select-currency"
              label="Provinsi"
              select
              sx={{
                mr: 1,
                height: 40,
                mt: 1,
                width: "100%"
              }}
              size="small"
              value={provinceCode}
              onChange={handleProvinceCodeChange}
            >
              <MenuItem key={"x"} value={"all"}>
                {provinceInputText}
              </MenuItem>
              {provinces.map((item) => (
                <MenuItem key={item.code} value={item.code}>
                  {item.name}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12} sm={2.4}>
            <TextField
              id="outlined-select-currency"
              label="Kota/Kab"
              select
              sx={{
                mr: 1,
                height: 40,
                mt: 1,
                width: "100%"
              }}
              size="small"
              value={regencyCode}
              onChange={handleRegencyCodeChange}
            >
              <MenuItem key={"x"} value={"all"}>
                {regencyInputText}
              </MenuItem>
              {regencies.map((item) => (
                <MenuItem key={item.code} value={item.code}>
                  {item.name}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12} sm={2.4}>
            <TextField
              id="outlined-select-currency"
              label="Kec"
              select
              sx={{
                mr: 1,
                mt: 1,
                height: 40,
                width: "100%"
              }}
              size="small"
              value={districtCode}
              onChange={handleDistrictCodeChange}
            >
              <MenuItem key={"x"} value={"all"}>
                {districtInputText}
              </MenuItem>
              {districts.map((item) => (
                <MenuItem key={item.code} value={item.code}>
                  {item.name}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12} sm={2.4}>
            <TextField
              id="outlined-select-currency"
              label="Kel"
              select
              sx={{
                mr: 1,
                mt: 1,
                height: 40,
                width: "100%"
              }}
              size="small"
              value={subDistrictCode}
              onChange={handleSubDistrictCodeChange} // Add this line to call the function
            >
              <MenuItem key={"x"} value={"all"}>
                {subDistrictInputText}
              </MenuItem>
              {subDistricts.map((item) => (
                <MenuItem key={item.code} value={item.code}>
                  {item.name}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
        </Grid>
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          flexDirection: "row",
          flexWrap: "wrap",
          gap: "15px"
        }}
      >
        <div
          style={{
            marginLeft: "15px",
          }}
        >
          <TextField
            id="select_column_name"
            label="Search by"
            select
            sx={{ height: 40, mt: 1, mr: 1, width: 190 }}
            size="small"
            value={filterColumnName}
            onChange={(e) => {
              const newFilterColumnName = e.target.value;
              const selectedColumn = surveyFilterColumnName.find(
                (column) => column.value === newFilterColumnName
              );

              setFilterColumnName(newFilterColumnName);
              setFilterColumnOperator(selectedColumn.operator);

              if (newFilterColumnName === "") {
                setTempColumnValue("");
                setFilterColumnValue("");
                setFilterColumnOperator("");
              }
            }}
            className="reporting-textfield"
          >
            {surveyFilterColumnName.map((data) => (
              <MenuItem value={data.value} key={data.value}>
                {data.label}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            sx={{
              mr: 1,
              mt: 1,
              height: 40,
            }}
            name="column_value"
            label="Cari"
            size="small"
            value={tempColumnValue}
            onChange={(e) => setTempColumnValue(e.target.value)}
            disabled={filterColumnName === ""}
          />

          <Button
            disableRipple
            sx={{
              backgroundImage: "linear-gradient(#0ab9cc, #069dae)",
              border: "1px solid hsl(186, 89.90%, 27.30%)",
              borderRadius: "4px",
              color: "#fff",
              fontSize: { xs: "14px", sm: "16px" },
              padding: "4px 10px",
              textTransform: "none",
              mt: 1,
              mr: 1,
              "&:hover": {
                backgroundImage: "linear-gradient(#0991a2, #057d8c)",
              },
            }}
            type="button"
            disabled={isLoading || filterColumnName === ""}
            onClick={() => {
              setPage(1);
              if (filterColumnName && tempColumnValue) {
                setFilterColumnValue(tempColumnValue);
              }
            }}
          >
            {isLoading ? "Loading..." : "Cari"}
          </Button>
          <Button
            disableRipple
            sx={{
              backgroundImage: "linear-gradient(#0ab9cc, #069dae)",
              border: "1px solid hsl(186, 89.90%, 27.30%)",
              borderRadius: "4px",
              color: "#fff",
              fontSize: { xs: "14px", sm: "16px" },
              padding: "4px 10px",
              textTransform: "none",
              mt: 1,
              mr: 1,
              "&:hover": {
                backgroundImage: "linear-gradient(#0991a2, #057d8c)",
              },
            }}
            onClick={handleResetFilter}
            disabled={isLoading}
          >
            {isLoading ? "Loading..." : "Reset Filter"}
          </Button>
        </div>
        <div style={{ display: "flex", justifyContent: "end" }}>
          <Button
            disableRipple
            onClick={createDataSurveyProcess}
            disabled={isLoading}
            sx={{
              backgroundImage: "linear-gradient(#0ab9cc, #069dae)",
              border: "1px solid hsl(186, 89.90%, 27.30%)",
              borderRadius: "4px",
              color: "#fff",
              fontSize: { xs: "14px", sm: "16px" },
              padding: "4px 10px",
              textTransform: "none",
              mt: 1,
              mr: 1,
              ml: '15px',
              "&:hover": {
                backgroundImage: "linear-gradient(#0991a2, #057d8c)",
              },
            }}
          >
            {isLoading ? "Loading..." : "Process"}
          </Button>

          <Button
            disableRipple
            onClick={handleConfirmationExport}
            disabled={isLoading}
            sx={{
              backgroundImage: "linear-gradient(#0ab9cc, #069dae)",
              border: "1px solid hsl(186, 89.90%, 27.30%)",
              borderRadius: "4px",
              color: "#fff",
              fontSize: { xs: "14px", sm: "16px" },
              padding: "4px 10px",
              textTransform: "none",
              mt: 1,
              mr: 1,
              "&:hover": {
                backgroundImage: "linear-gradient(#0991a2, #057d8c)",
              },
            }}
          >
            {isLoading ? "Loading..." : "Download"}
          </Button>
        </div>
      </div>

      <ModalConfirmation
        open={openDialogConfirmationExport}
        onClose={handleCloseDialog}
        title={'Konfirmasi Download'}
        confirmationText={'Yes'}
        description={`Ditemukan ${viewDataExport.title} terakhir diproses pada ${viewDataExport.process_at}. Apakah anda yakin ingin download rawdata ini?`}
        isLoading={isLoading}
        handleClick={handleExport}
      />
      {/* Modal Add New Project */}
      <Modal
        open={modalAdd}
        onClose={() => setModalAdd(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{ border: 0 }}
      >
        <Box sx={style}>
          <TextField
            id="outlined-select-currency"
            label="Download - Project Type"
            select
            sx={{ width: 400 }}
            size="small"
            value={selectedDownload}
            onChange={(event) => setSelectedDownload(event.target.value)}
          >
            {filterDownload.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>
          {/* File Input */}
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <BootstrapButton
              variant="contained"
              disableRipple
              sx={{ width: 400, mt: 2, height: 50 }}
            // onClick={handleDownload}
            >
              Download
            </BootstrapButton>
          </div>
        </Box>
      </Modal>

      {surveyData.length > 0 ? (
        <div>
          <Paper
            sx={{
              mt: 2,
              ml: 2,
              mr: 2,
              mb: 2,
              borderRadius: "10px",
              overflow: "auto"
            }}
          >
            <TableContainer component={Paper} style={{ width: "2300px" }}>
              <Table stickyHeader aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <StyledTableCell
                      align="center"
                      style={{ color: "white" }}
                      onClick={() => handleSort("store_id")}
                    >
                      KODE OUTLET {renderSortIcon("store_id")}
                    </StyledTableCell>
                    <StyledTableCell
                      align="center"
                      style={{ color: "white" }}
                      onClick={() => handleSort("store_name")}
                    >
                      NAMA TOKO {renderSortIcon("store_name")}
                    </StyledTableCell>
                    <StyledTableCell
                      align="center"
                      style={{ color: "white" }}
                      onClick={() => handleSort("store_type")}
                    >
                      TIPE TOKO {renderSortIcon("store_type")}
                    </StyledTableCell>
                    <StyledTableCell
                      align="center"
                      style={{ color: "white" }}
                      onClick={() => handleSort("audit_status")}
                    >
                      STATUS {renderSortIcon("audit_status")}
                    </StyledTableCell>
                    <StyledTableCell
                      align="center"
                      style={{ color: "white" }}
                      onClick={() => handleSort("user_name_surveyor")}
                    >
                      USERNAME SURVEYOR {renderSortIcon("user_name_surveyor")}
                    </StyledTableCell>
                    <StyledTableCell
                      align="center"
                      style={{ color: "white" }}
                      onClick={() => handleSort("date_modified")}
                    >
                      DATE UPLOADED {renderSortIcon("date_modified")}
                    </StyledTableCell>
                    <StyledTableCell
                      align="center"
                      style={{ color: "white" }}
                      onClick={() => handleSort("date_of_datacollected")}
                    >
                      START AUDITING {renderSortIcon("date_of_datacollected")}
                    </StyledTableCell>
                    <StyledTableCell
                      align="center"
                      style={{ color: "white" }}
                      // onClick={() => handleSort("province_name")}
                    >
                      PROVINSI {renderSortIcon("province_name")}
                    </StyledTableCell>
                    <StyledTableCell
                      align="center"
                      style={{ color: "white" }}
                      // onClick={() => handleSort("regency_name")}
                    >
                      KOTA/KABUPATEN {renderSortIcon("regency_name")}
                    </StyledTableCell>
                    <StyledTableCell
                      align="center"
                      style={{ color: "white" }}
                      // onClick={() => handleSort("district_name")}
                    >
                      KECAMATAN {renderSortIcon("district_name")}
                    </StyledTableCell>
                    <StyledTableCell
                      align="center"
                      style={{ color: "white" }}
                      // onClick={() => handleSort("sub_district_name")}
                    >
                      KELURAHAN {renderSortIcon("sub_district_name")}
                    </StyledTableCell>
                    <StyledTableCell align="center" style={{ color: "white" }}>
                      QC Data
                    </StyledTableCell>
                    <StyledTableCell align="center" style={{ color: "white" }}>
                      Surveyor Data
                    </StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {surveyData.length > 0 ? (
                    surveyData.map((row) => (
                      <TableRow key={row.id}>
                        <TableCell align="left">{row.store_id}</TableCell>
                        <TableCell align="left">{row.store_name}</TableCell>
                        <TableCell align="left">{row.store_type}</TableCell>
                        <TableCell align="center">
                          {(() => {
                            switch (row.audit_status) {
                              case "Valid":
                                return (
                                  <div
                                    style={{
                                      background: "lightblue",
                                      color: "white",
                                      padding: "10px",
                                    }}
                                  >
                                    Valid
                                  </div>
                                );
                              case "Not Started":
                                return (
                                  <div
                                    style={{
                                      background: "red",
                                      color: "white",
                                      padding: "10px",
                                    }}
                                  >
                                    Not Started
                                  </div>
                                );
                              case "Closed":
                                return (
                                  <div
                                    style={{
                                      background: "green",
                                      color: "white",
                                      padding: "10px",
                                    }}
                                  >
                                    Closed
                                  </div>
                                );
                              case "On Progress":
                                return (
                                  <div
                                    style={{
                                      background: "orange",
                                      color: "white",
                                      padding: "10px",
                                    }}
                                  >
                                    On Progress
                                  </div>
                                );
                              default:
                                return row.audit_status;
                            }
                          })()}
                        </TableCell>
                        <TableCell align="left">
                          {row.user_name_surveyor}
                        </TableCell>
                        <TableCell align="left">{row.date_uploaded}</TableCell>
                        <TableCell align="left">{row.start_auditing}</TableCell>
                        <TableCell align="left">{row.province_name}</TableCell>
                        <TableCell align="left">{row.regency_name}</TableCell>
                        <TableCell align="left">{row.district_name}</TableCell>
                        <TableCell align="left">
                          {row.sub_district_name}
                        </TableCell>
                        <TableCell align="center">
                          {row.qc_data_exist === true ? (
                            <Tooltip
                              title="View QC Data"
                              onClick={() =>
                                openNewTab(
                                  row.id,
                                  row.audit_status,
                                  surveyType,
                                  true
                                )
                              }
                            >
                              <IconButton>
                                <BackupTableIcon />
                              </IconButton>
                            </Tooltip>
                          ) : (
                            ""
                          )}
                        </TableCell>
                        <TableCell align="center">
                          <Tooltip
                            title="View Data Trx"
                            onClick={() =>
                              openNewTab(
                                row.id,
                                row.audit_status,
                                surveyType,
                                false
                              )
                            }
                          >
                            <IconButton>
                              <TableViewIcon />
                            </IconButton>
                          </Tooltip>
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={13} align="center">
                        {initialText}
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
              <TablePagination
                component="div"
                count={totalRows}
                page={page - 1}
                onPageChange={handleChangePage}
                rowsPerPage={size}
                onRowsPerPageChange={handleChangeRowsPerPage}
                rowsPerPageOptions={[5, 10, 25, 50]}
              />
            </TableContainer>
          </Paper>
        </div>
      ) : (
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            justifyContent: "center",
            display: "flex",
          }}
        >
          {/* <CircularProgress /> */}
          <p
            style={{
              fontWeight: "600",
              fontSize: "20px",
              marginTop: "5px",
              marginLeft: "20px",
            }}
          >
            {initialText}
          </p>
        </div>
      )}
    </div>
  );
}

export default DataSurvey;
